import { createFileRoute } from "@tanstack/react-router"

import { VehiclesPage } from "@/trips/components/mileage/vehicles-page"

export const Route = createFileRoute("/_app-shell/vehicles")({
  head: () => ({ meta: [{ title: "Vehicles - Kestly" }] }),
  component: VehiclesPage,
})
